import { Maybe } from "graphql";

import { StrapiImage } from "ui/StrapiImage";

import { CatalogProductCard } from "../CatalogProductCard";

type CatalogProductCardLegacyProps = {
  brand: string;
  slug: string;
  modelName: string;
  image: {
    alternativeText: Maybe<string>;
    name?: string;
    medium?: string;
    thumbnail?: string;
  };
};

export const CatalogProductCardLegacy = ({
  brand,
  slug,
  modelName,
  image,
}: CatalogProductCardLegacyProps) => {
  return (
   <CatalogProductCard type="legacy" href={`/smartphone${slug}`}>
      {/* Infos */}
      <div className="flex-1 py-12 w-full max-w-[240px] xs:py-0 xs:px-5">
        <p className="text-sm sm:text-base">{brand}</p>
        <p className="text-lg font-semibold tracking-tighter sm:text-2xl">{modelName}</p>
      </div>

      {/* Image */}
      <StrapiImage
        image={{
          alternativeText: image.alternativeText,
          medium: { url: image.medium, name: image.name },
          thumbnail: { url: image.thumbnail, name: image.name },
        }}
        size="medium"
        sizes="40vw"
        className="ml-5 w-[92px] h-[120px] grayscale sm:w-[165px] sm:h-[165px] xs:ml-0"
      />
    </CatalogProductCard>
  );
};
